module.exports = __webpack_public_path__ + "static/media/packc2.be1a76c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/packc2.jpg
// module id = 888
// module chunks = 0